import { render, staticRenderFns } from "./ActionColumn.vue?vue&type=template&id=5cb78d0e&"
import script from "./ActionColumn.vue?vue&type=script&lang=ts&"
export * from "./ActionColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports